import ImgEmail from './img/email.png';
import ImgMess from './img/messenger.png';
import ImgPhone from './img/phone.png';
import ImgSms from './img/sms.png';

export const listSetting = [
  {
    name: 'По СМС на телефон',
    title: 'СМС',
    descr: 'Оставайтесь с нами: будьте в курсе акций и скидок. Пишем не чаще раза в месяц.',
    info: 'Всё равно отказаться?',
    img: ImgSms,
    currentConsent: 'consent_to_sms',
  },
  {
    name: 'По электронной почте',
    title: 'Email',
    descr: 'Оставайтесь с нами: получайте эксклюзивные скидки, полезные советы и первыми узнавайте о новинках.',
    info: 'Всё равно отказаться?',
    img: ImgEmail,
    currentConsent: 'consent_to_email',
  },
  {
    name: 'В мессенджеры',
    title: 'Мессенджеры',
    descr: 'Оставайтесь с нами: получайте спецпредложения и важные напоминания напрямую в мессенджер. Пишем не чаще раза в месяц.',
    info: 'Всё равно отказаться?',
    img: ImgMess,
    currentConsent: 'consent_to_msgrs',
  },
  {
    name: 'По телефону',
    title: 'Телефонные звонки',
    descr: 'Оставайтесь с нами: узнайте спецпредложения и важные напоминания. Позвоним не чаще 2-3 раз в год.',
    info: 'Всё равно отказаться?',
    img: ImgPhone,
    currentConsent: 'consent_to_call',
  },
];
